import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loading } from "@/components/Loading";
import { ScrollToTop } from "@/components/ScrollToTop";

const AboutPage = lazy(() => import("./pages/about"));
const AdvantagesPage = lazy(() => import("./pages/advantages"));
const TeamPage = lazy(() => import("./pages/team"));
const ServicePage = lazy(() => import("./pages/service"));
const HomePage = lazy(() => import("./pages/home"));
const CaseDetailPage = lazy(() => import("./pages/caseDetail"));
const SearchCasePage = lazy(() => import("./pages/searchCase"));
const BasicLayout = lazy(() => import("./layouts/Basic"));

const App = () => {
  return (
    <BrowserRouter basename="/">
      {/* 在路由切换时，新页面跳转到页面顶部 */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<BasicLayout />}>
          <Route
            index
            element={
              <Suspense fallback={<Loading />}>
                <HomePage />
              </Suspense>
            }
          />
          <Route
            path="/team"
            index
            element={
              <Suspense fallback={<Loading />}>
                <TeamPage />
              </Suspense>
            }
          />
          <Route
            path="/service"
            index
            element={
              <Suspense fallback={<Loading />}>
                <ServicePage />
              </Suspense>
            }
          />
          <Route
            path="/advantages"
            index
            element={
              <Suspense fallback={<Loading />}>
                <AdvantagesPage />
              </Suspense>
            }
          />
          <Route
            path="/about"
            index
            element={
              <Suspense fallback={<Loading />}>
                <AboutPage />
              </Suspense>
            }
          />
          <Route
            path="/searchCase"
            element={
              <Suspense fallback={<Loading />}>
                <SearchCasePage />
              </Suspense>
            }
          />
          <Route
            path="/caseDetail"
            element={
              <Suspense fallback={<Loading />}>
                <CaseDetailPage />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
